// extracted by mini-css-extract-plugin
export var active = "MobileNav-module--active--6dsxL";
export var circle = "MobileNav-module--circle--l5k98";
export var closeButton = "MobileNav-module--closeButton--nojSZ";
export var link = "MobileNav-module--link--MYsjU";
export var logotype = "MobileNav-module--logotype--ldUDq";
export var wrapper = "MobileNav-module--wrapper--W7H3G";